import React, { ReactNode, createContext, useContext, useState, useRef } from 'react';
import { DEFAULT_MODE } from '../constants/mapModes';

interface IVariables {
	map?: any;
	mapRef?: any;
	selectedFeatureProperty?: any;
	hoveredFeature?: any;
	mapMode?: string;
}

interface IFunctions {
	setMap?: any;
	setSelectedFeatureProperty?: any;
	setHoveredFeature?: any;
	setMapMode?: any;
}

const MapContext = createContext<[IVariables, IFunctions]>([{}, {}]);

interface IProvider {
	children: ReactNode;
}
export const MapProvider = (props: IProvider) => {
	const [map, setMap] = useState();
	const mapRef = useRef();
	const [selectedFeatureProperty, setSelectedFeatureProperty] = useState<string>('Demo Property');
	const [hoveredFeature, setHoveredFeature] = useState<any>(undefined);
	const [mapMode, setMapMode] = useState<string>(DEFAULT_MODE);

	const value: [IVariables, IFunctions] = [
		{
			map,
			mapRef,
			selectedFeatureProperty,
			hoveredFeature,
			mapMode,
		},
		{
			setMap,
			setSelectedFeatureProperty,
			setHoveredFeature,
			setMapMode,
		},
	];

	return <MapContext.Provider value={value} {...props} />;
};

export const useMapContext = () => {
	const context = useContext(MapContext);
	if (!context) {
		throw new Error('useMapContext must be used within a MapProvider');
	}
	return context;
};
